import { createActions } from 'redux-actions'

export const {
  jobApplication: {
    show: showJobApplication,
    close: closeJobApplication,
    loadAttachmentsSuccess,
    setDraftAttachmentsToReuse,
    sendDraftAttachmentsToReuse,
    submit,
    submitSuccess,
    submitFailure,
    loadJobForApplication,
    loadJobForApplicationSuccess,
    loadJobForApplicationError
  }
} = createActions({
  JOB_APPLICATION: {
    SHOW: payload => payload,
    CLOSE: payload => payload,
    // currently used only for gjs tracking of redirect application
    LOAD: payload => payload,
    // currently it's used for gjs, so we only care about success
    LOAD_SUCCESS: [payload => payload, (payload, meta) => meta],
    LOAD_ATTACHMENTS_SUCCESS: payload => payload,
    SET_DRAFT_ATTACHMENTS_TO_REUSE: payload => payload,
    SEND_DRAFT_ATTACHMENTS_TO_REUSE: payload => payload,
    SUBMIT: [payload => payload, (payload, meta) => meta],
    SUBMIT_SUCCESS: response => response,
    SUBMIT_FAILURE: (
      {
        message,
        errors: {
          __all__: $messages = [],
          ...errors
        } = {}
      }
    ) => (
      {
        $messages: [...$messages, ...(message ? [message] : [])],
        ...errors
      }
    ),
    LOAD_JOB_FOR_APPLICATION: payload => payload,
    LOAD_JOB_FOR_APPLICATION_SUCCESS: payload => payload,
    LOAD_JOB_FOR_APPLICATION_ERROR: payload => payload,
    ADD_EXCLUDE_ID: payload => payload
  }
})
